awardData.classy.controller({
    name: 'AwardDataController',
    inject: ['$scope', '$http', 'ApplicationSideBarService', 'AskSchoolSpecificQuestionsModelService', 'FamilyModelService', 'ApplicationService', 'SchoolModelService', 'RealEstateModelFactory',
        'CalculationService', 'AlertService', '$sce', '$modal', '$q', 'MedianExpenseModelService', 'authServiceFactory', 'SliderFactory', 'SliderService', 'zillowDataModelFactory'],
    init: function()
    {
        this.$.ApplicationSideBarService = this.ApplicationSideBarService;
        this.$.ApplicationService = this.ApplicationService;
        this.$.CalculationService = this.CalculationService;
        this.$.AlertService = this.AlertService;
        this.$.versionNo = versionNo;
        this.$.$sce = this.$sce;
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.newLetter = 0;
        this.$.familyLetter = '';
        this.$.questions = this.AskSchoolSpecificQuestionsModelService.get();
        this.$.names = [];
        this.$.names.applicants = [];
        this.$.names.children = [];
        this.$.names.dependants = [];
        this.$.names.parents = [];
        this.$.SliderService = this.SliderService;
        for (var i = 0; i < this.ApplicationService.getAwardData().applicants.length; i++) {
            this.$.names.applicants.push(this.ApplicationService.getAwardData().applicants[i].App_First);
        }
        for (var j = 0; j < this.ApplicationService.getAwardData().family[0].children.length; j++) {
            this.$.names.children.push(this.ApplicationService.getAwardData().family[0].children[j].Chi_First_Name)
        }
        for (var k = 0; k < this.ApplicationService.getAwardData().family[0].dependant.length; k++) {
            this.$.names.dependants.push(this.ApplicationService.getAwardData().family[0].dependant[k].Dep_First_Name)
        }
        for (var m = 0; m < this.ApplicationService.getAwardData().family[0].data.length; m++) {
            this.$.names.parents.push(this.ApplicationService.getAwardData().family[0].data[m].Fam_Name_First)
        }
        this.$.translateButtonVisible = this.checkTranslation(this.ApplicationService.getFamilyData().data[0].Fam_Letter);
        this.$.expensesOpen = false;
        this.$.incomelabel = this.ApplicationService.getIncomeLabel();
    },
    getLetter: function() {
        let parent = this;
        this.$http.get("/api/family/"+this.ApplicationService.getFamilyData().data[0].familyID+"/letter").then(function(results) {
            parent.ApplicationService.getFamilyData().data[0].Fam_Letter = results.data;
        })
    },
    checkTranslation: function(sourceText) {
        // check to see if the letter is in english; if so, don't allow them to translate
        let sourceText1 = angular.copy(sourceText).toLowerCase();
        let englishWords = ["the", "that", "have", "thank", "you", "this", "our", "from"];

        // check to see if the school name contains one of the words and is in the letter
        if (this.$.schoolinfo.School_Name.toLowerCase().split(" ").some(iterateSource) &&
            sourceText1.indexOf(this.$.schoolinfo.School_Name.toLowerCase())) {
            sourceText1 = sourceText1.replace(this.$.schoolinfo.School_Name, "");
        }
        let sourceTextArray = sourceText1.split(" ");
        return (!sourceTextArray.some(iterateSource));

        function iterateSource(sourceWord) {
            return englishWords.some(checkEnglish);
            function checkEnglish(englishWord) {
                return englishWord === sourceWord;
            }
        }
    },
    conversion: function() {
        this.$.familyLetter.replace()
    },
    formatAnswer: function(question)
    {
        //Move this to the backend
        var temp;
        var answer = question.Answer;
        if (question.Q_type == 2)
        {
            temp = question.Answer.split("|");
            temp[0] = temp[0].replaceAll(",");
            temp[0] = temp[0].addCommas();
            if (question.money==1)
                temp[0] = "$" + temp[0];
            if (temp[1]!=='#')
                answer = temp[0] + " - " + temp[1];
            else
                answer = temp[0];
        }
        return answer.toString();
    },
    printList: function() {
        var mywindow = window.open('', 'my div', 'height=400,width=800');
        mywindow.document.write('<html><head><title>my div</title>');
        mywindow.document.write('</head><body >');
        mywindow.document.write($('#letterHtml').html());
        mywindow.document.write('</body></html>');
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10
        mywindow.print();
        mywindow.close();
        return true;
    },
    addLetter: function()
    {
        if (this.$.newLetter==null)
            this.$.newLetter = 0;
        this.$.newLetter = !this.$.newLetter;
    },
    saveLetter: function()
    {
        this.$.putObject = this.FamilyModelService.get();
        var queue = [];
        var deferred = this.$q.defer();
        for (var i = 0; i < this.$.putObject.length; i++) {
            this.$.familyLetter = $('#familyLetter').redactor('code.get');
            this.$.putObject[i].Fam_Letter = this.$.familyLetter;
            queue.push(this.FamilyModelService.put(this.$.putObject[i].recordID, this.$.putObject[i]));
        }
        this.$q.all([queue]).then(function (results) {
            deferred.resolve(results);
        });
        return deferred.promise;
    },
    getFamilyNo: function()
    {
        return parseInt(this.ApplicationService.getFamilyNo()) + 1;
    },
    openFamilyPDF: function()
    {
        var familyID = this.$.ApplicationService.getFamilyID();
        let domain = this.authServiceFactory.getDomain();
        var url = "https://" + domain + "//family_side/faAppPdf.php?familyID=" + familyID;
        var win = window.open(url, '_blank');
        win.focus();
    },
    getMedianExpense: function(key)
    {
        for (var i = 0; i < this.MedianExpenseModelService.get().length; i++)
        {
            if (this.MedianExpenseModelService.get()[i].pKey == key)
                return this.MedianExpenseModelService.get()[i];
        }
    },
    medianDropDownChange: function(value)
    {
        //this.$.median = this.getMedianExpense(value.id);
    },
    toggleExpenses: function()
    {
        this.$.expensesOpen = !this.$.expensesOpen;
    },
    displayTranslation: function(){
        
        let sourceText = this.ApplicationService.getFamilyData().data[0].Fam_Letter;

        gapi.client.init({
          'apiKey': 'AIzaSyBd15gZH8lhoDBNzxNLJ9OyntxQN-4-Tjs',
          'discoveryDocs': ['https://www.googleapis.com/discovery/v1/apis/translate/v2/rest'],
        }).then(() => {

          gapi.client.language.translations.list({
            format: 'text',  
            q: sourceText,
            target: 'en',
          }).then((response) => {
            this.$.ApplicationService.getFamilyData().data[0].Fam_Letter = response.result.data.translations[0].translatedText;
            this.$.$apply();
            });
        });
        
    },
    getField: function(item, field)
    {
        if (item['x' + field] === null || item['x' + field].length===0 || item[field] == item['x' + field])
            return item[field]
        else
            return item['x' + field];
    },
    setPartial: function(partial, header)
    {
        this.SliderService.pushSlider(new this.SliderFactory(partial, header, 's'));
    }
});

stateProviders.push({
    name: 'schoolside.application.awardData',
    url: '/awardData',
    templateUrl: 'fast/submodules/schoolside/applications/mainContent/tabs/awardData/awardData.html?v=' + versionNo,
    controller: 'AwardDataController'
});


/* End accountInfo Module */
